<template>
  <div class="updateclasshour">
    <div class="classsch">
      班级选择:
      <el-select v-model="classid" placeholder="选择你的班级" @change="classchange">
        <el-option v-for="(item, i) in classlist" :key="i" :label="item.name" :value="item.classid"> </el-option>
      </el-select>
    </div>
    <div class="tablemain">
      <el-table :data="classhourlist" border :row-class-name="tableRowClassName" height="700">
        <!-- <el-table-column prop="id" label="编号" width="80">
        </el-table-column> -->
        <el-table-column prop="course" label="课程"> </el-table-column>
        <!-- <el-table-column prop="tea" label="老师">
        </el-table-column> -->
        <el-table-column prop="course" label="上课时间" width="80">
          <template slot-scope="scope">
            {{ upperCaseNumber[new Date(scope.row.time).getDay()] }}
          </template>
        </el-table-column>
        <el-table-column prop="time" label="时间"> </el-table-column>
        <el-table-column prop="course" label="操作">
          <template slot-scope="scope">
            <el-button @click="gethomework(scope.row)" :type="scope.row.stuurl ? 'primary' : 'default'" size="small"
              >上传/下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :close-on-click-modal="false" title="上传作业/下载报告" :visible.sync="qjlogflag" width="100%" center>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="上课时间">{{
          upperCaseNumber[new Date(classhourinfo.time).getDay()]
        }}</el-descriptions-item>
        <el-descriptions-item label="时间">{{ classhourinfo.time }}</el-descriptions-item>
        <el-descriptions-item label="你的作业" :span="2">
          <div class="dialogitem">
            <span v-if="homeworkUploaded">
              <span v-for="(url, i) in homeworkUrls" :key="i" class="homework-item">
                <i class="el-icon-close homework-delete" @click="removeUploadedHomework(url)" />
                <el-button type="text" size="small" @click="download(url)">作业{{ i + 1 }}</el-button>
              </span>
            </span>

            <span v-else>暂未上传</span>
            &nbsp;&nbsp;
            <el-button type="default" size="mini" @click="triggerUpload">上传</el-button>
            &nbsp;&nbsp;
            <input type="file" style="display: none" ref="fileInput" @change="handleFileChange" />
            <el-button type="primary" size="mini" @click="saveteafile">保存</el-button>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="老师报告" :span="2">
          <div class="dialogitem">
            <el-button
              type="text"
              size="small"
              v-if="classhourinfo.teaurl"
              @click="download(classhourinfo.teaurl || url)"
              >下载报告
            </el-button>
            <span v-else>暂未上传</span>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import Config from '@/util/config';
import { getJapiServerData, getServerData } from '@/util/data/';
import { ActionUtils } from '@/util/action';

export default {
  props: {
    title: String,
  },
  data() {
    return {
      classid: '',
      classlist: [],
      remark: '',
      userinfo: [],
      classhourlist: [],
      homeworklist: [],
      url: '',
      classhourinfo: [],
      qjlogflag: false,
      upperCaseNumber: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      upperCaseNumberEnglish: ['Sun', 'Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat'],
    };
  },
  computed: {
    homeworkUrls() {
      return this.url ? this.url.split('|') : [];
    },
    homeworkUploaded() {
      return this.homeworkUrls.length > 0;
    },
  },
  mounted() {
    this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
    console.log(this.userinfo, window.innerWidth);

    this.setViewportZoom(1.0);
    // console.log(userinfo, window.innerWidth);
    this.selectclass();
  },
  methods: {
    setViewportZoom(scale) {
      var metaTag = document.querySelector('meta[name="viewport"]');
      if (metaTag) {
        // 设置或更新meta标签的内容
        metaTag.setAttribute(
          'content',
          'width=device-width, initial-scale=' + scale + ', maximum-scale=' + scale + ', user-scalable=no',
        );
      } else {
        // 如果不存在，则创建一个新的meta标签
        metaTag = document.createElement('meta');
        metaTag.setAttribute('name', 'viewport');
        metaTag.setAttribute(
          'content',
          'width=device-width, initial-scale=' + scale + ', maximum-scale=' + scale + ', user-scalable=no',
        );
        document.head.appendChild(metaTag);
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (new Date(row.time).getTime() < new Date().getTime()) {
        return 'success-row';
      }
    },
    classchange(e) {
      this.classid = e;
      setTimeout(() => {
        this.getclasshor();
      }, 200);
    },
    saveremark(id, cid) {
      const url = Config.url.efunapi.url;
      const method = Config.url.efunapi.method.saveclasshourremark;
      const params = {
        id: id + '',
        teanotice: this.remark
          .replace(/\'|\’/g, '/d')
          .replace(/\"/g, '/s')
          .replace(/\n/g, '/br')
          .replace(/ /g, '&nbsp;')
          .replace(/\r/g, '/br')
          .replace(/\r\n/g, '/br')
          .replace(/\./g, '/dian')
          .replace(/\-/g, '/gang')
          .replace(/\+/g, '/jia')
          .replace(/\,/g, '/dou'),
      };
      getServerData(
        url,
        method,
        params,
        (result) => {
          console.log('remark', result);
          this.$message({
            type: 'success',
            message: 'save success!',
          });
        },
        0.5,
      );
    },
    saveteafile() {
      const url = 'japi/work';
      const params = {
        chid: this.classhourinfo.id + '',
        url: this.url,
      };
      console.log(params);
      getJapiServerData(
        url,
        params,
        'POST',
        (res) => {
          console.log('coursedel', res);
          if (res.code == 200) {
            this.$message.success('保存成功');
            this.url = '';
            this.qjlogflag = false;
            setTimeout(() => {
              this.getclasshor();
            }, 200);
          }
        },
        0.5,
      );
    },
    download(e) {
      const target = e.startsWith('http') ? e : `https://orbit-x-edu.us/${e}`;
      ActionUtils.open(target);
    },
    gethomework(item) {
      console.log(item);
      this.qjlogflag = true;
      this.classhourinfo = item;
    },
    triggerUpload() {
      this.$refs.fileInput.click(); // 触发input的点击事件
    },
    handleFileChange(event) {
      const file = event.target.files[0]; // 获取选中的文件
      // 处理文件上传的逻辑...
      let xhr = new XMLHttpRequest();
      const formdata = new FormData();
      formdata.append('type', 2);
      formdata.append('file', file);
      xhr.open('POST', 'https://orbit-x-edu.us/japi/file/upload', true);
      // xhr.setRequestHeader('Cookie', document.cookie)
      // console.log(document.cookie)
      xhr.setRequestHeader('token', localStorage.getItem('token'));
      xhr.send(formdata);
      const that = this;
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          const res = JSON.parse(xhr.responseText);
          if (res.code == 200) {
            this.$message.success('上传成功');
            this.url = this.url.length > 1 ? this.url + '|' + res.message : res.message;
            // this.saveteafile()
          } else if (res.code == 1003) {
            this.$message.error('用户信息过期请重新登录');
            this.$router.push('/login');
          } else {
            this.$message.error(res.message);
          }

          console.log(res.message);
        }
      };
    },
    getclasshor() {
      const url = 'japi/class_hour/getByClass/' + this.classid;
      const params = {};
      getJapiServerData(
        url,
        params,
        'GET',
        (res) => {
          if (res.code == 200) {
            console.log('classhour', res);
            this.classhourlist = res.data.sort((a, b) => {
              return new Date(a.time).getTime() - new Date(b.time).getTime();
            });
          }
        },
        0.5,
      );
    },
    selectclass() {
      console.log(this.classname);
      const url = Config.url.efunapi.url;
      const method = Config.url.efunapi.method.getclassbyuserid;
      const params = {
        id: this.userinfo.id + '',
      };
      getServerData(
        url,
        method,
        params,
        (result) => {
          console.log('classlist', result);
          this.classlist = result.data.rows;
        },
        0.5,
      );
    },
    removeUploadedHomework(url) {
      this.url = this.homeworkUrls.filter((item) => item !== url).join('|');
    },
  },
};
</script>
<style lang="less" scoped>
.updateclasshour {
  width: 100%;

  .classsch {
    width: 460px;
    margin: 10px auto;
    position: relative;

    .classlistbox {
      position: absolute;
      background-color: #f5f7fa;
      width: 280px;
      left: 100px;
      max-height: 300px;
      overflow-y: auto;
      padding: 10px;
      z-index: 1;

      .schitem {
        margin-bottom: 12px;
        cursor: pointer;
        padding: 10px 0;
      }

      .schitem:hover {
        background-color: #409eff;
        color: white;
        border-radius: 5px;
      }
    }
  }

  .tablemain {
    margin-top: 20px;

    .clickbox {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;
    }
  }

  .dialogitem {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    //background-color: #f2f2f2;
    padding: 5px 5px;
    margin: 10px;
    font-size: 16px;
    position: relative;

    .schlistbox {
      position: absolute;
      background-color: #d9dee4;
      width: 231px;
      left: 132px;
      top: 52px;
      max-height: 300px;
      overflow-y: auto;
      padding: 10px;
      z-index: 1;

      .nodata {
        text-align: center;
        font-size: 12px;
      }

      .schitem {
        margin-bottom: 12px;
        cursor: pointer;
        padding: 10px 0;
      }

      .schitem:hover {
        background-color: #409eff;
        color: white;
        border-radius: 5px;
      }
    }
  }

  .stuitembox {
    display: flex;
    flex-wrap: wrap;

    .stusinfobox {
      width: 100%;
    }
  }
}

.remarkbox {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  align-content: space-around;

  /deep/ .el-textarea__inner {
    margin-bottom: 10px;
  }
}

/deep/ .el-table .success-row {
  background: #c1e8f4a1;
}
.homework-item {
  display: inline-block;
  position: relative;
  //border: 1px solid #eee;
  padding-left: 10px;
  padding-right: 20px;
}

.homework-delete {
  position: absolute;
  right: 0;
  top: -8px;
  border: 1px solid #f56c6c;
  color: #f56c6c;
  border-radius: 50%;
  font-size: 10px;
  padding: 2px;
  display: inline;
  cursor: pointer;
}
</style>
